import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider, createUnifiedTheme, palettes } from '@backstage/theme';
import { brand } from './brand';

function brandedTheme(variant: 'light' | 'dark') {
  const base = palettes[variant];
  return createUnifiedTheme({
    fontFamily: brand.fontFamily,
    palette: {
      ...base,
      primary: { ...base.primary, main: brand.colors.primary[variant] },
      navigation: {
        ...base.navigation,
        background: brand.colors.navBackground[variant],
        indicator: brand.colors.navIndicator[variant],
      },
    },
  });
}

const makeTheme = (variant: 'light' | 'dark') => {
  const theme = brandedTheme(variant);
  return ThemeBlueprint.make({
    name: variant,
    params: {
      theme: {
        id: variant,
        title: variant === 'light' ? 'Light' : 'Dark',
        variant,
        Provider: ({ children }) => (
          <UnifiedThemeProvider theme={theme}>{children}</UnifiedThemeProvider>
        ),
      },
    },
  });
};

export const brandingModule = createFrontendModule({
  pluginId: 'app',
  extensions: [makeTheme('light'), makeTheme('dark')],
});
